export const PRICE_TYPES = [
  { value: "fixed", label: "Fixed" },
  { value: "starting_at", label: "Starting at" },
  { value: "range", label: "Range" },
  { value: "quote", label: "Quote required" },
  { value: "not_disclosed", label: "Not disclosed" },
];

export const QUESTION_TYPES = [
  { value: "short_text", label: "Short text" },
  { value: "long_text", label: "Long text" },
  { value: "yes_no", label: "Yes or no" },
  { value: "single_select", label: "Single select" },
  { value: "number", label: "Number" },
  { value: "address", label: "Address" },
  { value: "date", label: "Date" },
];

export const AREA_TYPES = [
  { value: "postal_code", label: "Postal code" },
  { value: "city", label: "City" },
  { value: "radius", label: "Radius (miles)" },
];

export const DAYS = [
  { dow: 0, label: "Sun" }, { dow: 1, label: "Mon" }, { dow: 2, label: "Tue" },
  { dow: 3, label: "Wed" }, { dow: 4, label: "Thu" }, { dow: 5, label: "Fri" }, { dow: 6, label: "Sat" },
];

export function priceLabel(s: Record<string, unknown>): string {
  const t = s.price_type as string;
  const min = s.minimum_price as number | null;
  const max = s.maximum_price as number | null;
  if (t === "quote") return "Quote required";
  if (t === "not_disclosed") return "Not disclosed";
  if (t === "fixed") return min != null ? `$${min}` : "Fixed";
  if (t === "starting_at") return min != null ? `From $${min}` : "Starting at";
  if (t === "range") return min != null && max != null ? `$${min}–$${max}` : "Range";
  return t;
}
